<ng-container *ngIf="(birthdayPersonsToday$ | async) as birthdayPersonsToday">
    <div *ngIf="birthdayPersonsToday.length > 0" class="birthday-component-container">
        <h2 class="widget-header h4">
            <span i18n="birthdays header@@birthdays-header" class="widget-header birthday-title text-center">Birthday calendar</span>
            <span class="ml-1 header-birthdays-date">{{ today | date:'longDate'}}</span>
        </h2>
        <h3 class="text-muted h6" i18n="birthdays sub title@@birthdays-sub-title">Don't forget to congratulate your colleagues who have their birthday today.</h3>
        <h3 class="text-muted ml-1 h6" *ngIf="!environment.production">(The following is only visible in dev-mode. Current date query: {{dateToQuery}})</h3>
        <div class="row">
            <div class="col-12 col-sm-6 col-xxl-4 mt-5 pl-3 pr-3" *ngFor="let birthdayPersonToday of birthdayPersonsToday">
                <div class="birthday-content p-4 text-center h-100">
                    <div class="birthday-image mt-n5">
                        <a href="{{ birthdayPersonToday.Path }}" title="{{ birthdayPersonToday.PreferredName }}">
                            <ng-container *ngIf="birthdayPersonToday.photoUrl$ | async as src;else tempImg">
                                <div class="rounded-circle birthday-user-img" [ngStyle]="{'background-image': 'url(' + src + ')'}" title="{{ birthdayPersonToday.PreferredName }}"></div>
                            </ng-container>
                            <ng-template #tempImg>
                                <div class="letters accent-2-bg-color rounded-circle position-relative d-inline-block ml-3 mr-3" title="{{ birthdayPersonToday.PreferredName }}">
                                    <h3 class="mb-0 letters-text">{{ getPreferredNameLetters(birthdayPersonToday.PreferredName) }}</h3>
                                </div>
                            </ng-template>
                        </a>
                    </div>
                    <div class="birthday-title mt-2">
                        <h6 class="birthday-h6 text-break">
                            <a href="{{ birthdayPersonToday.Path }}" title="{{ birthdayPersonToday.PreferredName }}" class="link-text-color">
                                <span class="extra-bold">{{ birthdayPersonToday.PreferredName }}</span>
                            </a>
                        </h6>
                    </div>
                    <div class="birthday-department text-muted text-break">
                        <span>{{ birthdayPersonToday.Department }}</span>
                    </div>
                    <div class="mt-4">
                        <a [attr.href]="('https://teams.microsoft.com/l/chat/0/0?users=' + birthdayPersonToday.WorkEmail) | safe: 'url'" *ngIf="useTeamsCongratulations">
                            <i class="mr-1 ms-Icon ms-Icon--TeamsLogo align-bottom" aria-hidden="true"></i>
                            <span i18n="@@congratulate">Congratulate</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center mt-4" *ngIf="fetchedAmount > amountOfBirthdaysToDisplayCurrently && !loading">
            <div class="col-auto">
                <button mat-flat-button color="accent" class="birthday-show-more-btn" (click)="showMoreBirthdays()">
                    <span i18n="birthdays show more@@birthdays-show-more">Show more birthdays</span>
                    <i class="ml-2 ms-Icon ms-Icon--ChevronDown" aria-hidden="true"></i>
                </button>
            </div>
        </div>
        <div class="row justify-content-center mt-4" *ngIf="fetchedAmount < amountOfBirthdaysToDisplayCurrently && fetchedAmount > amountOfBirthdaysToDisplay && !loading">
            <div class="col-auto">
                <button mat-flat-button color="accent" class="birthday-show-more-btn" (click)="showLessBirthdays()">
                    <span i18n="birthdays show less@@birthdays-show-less">Show less birthdays</span>
                    <i class="ml-2 ms-Icon ms-Icon--ChevronUp" aria-hidden="true"></i>
                </button>
            </div>
        </div>
    </div>
    <div *ngIf="loading" class="mt-4">
        <div *ngIf="errorSubject$ | async as err; else innerLoading">
            <app-error-templates [error]="err.status" [componentName]="componentName"></app-error-templates>
        </div>
        <ng-template #innerLoading>
            <app-widget-placeholder></app-widget-placeholder>
        </ng-template>
    </div>
</ng-container>



